import clsx from 'clsx'
import { createElement } from 'react'
import { BardTocHeading as BardTocHeadingType } from '@/src/@types/statamic'

export default function BardTocHeading({ title, dept }: BardTocHeadingType) {
  return createElement(
    dept.value,
    {
      id: encodeURIComponent(title).toLowerCase(),
      className: clsx('scroll-mt-20 font-black', {
        'mb-6 mt-16! text-2xl md:text-7xl': dept.value === 'h2',
        'mb-4 mt-12! text-lg md:text-4xl': dept.value === 'h3',
      }),
    },
    title
  )
}
